import { Controller, useForm } from 'react-hook-form'

import { Box, Button, Radio } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

export type ImportType = 'compensations' | 'importResult'

type FormData = {
  importType: ImportType
}

const ImportModal = ({
  canImportCompensations,
  canImportResults,
  onClose,
  onSubmit,
}: {
  canImportCompensations?: boolean
  onClose: () => void
  onSubmit?: (importType: ImportType) => void
  canImportResults?: boolean
}) => {
  const getDefaultImportType = (): ImportType | undefined => {
    if (canImportCompensations) return 'compensations'
    if (canImportResults) return 'importResult'
    return undefined
  }

  const { control, handleSubmit } = useForm<FormData>({
    defaultValues: {
      importType: getDefaultImportType(),
    },
  })

  const isConfirmDisabled = !canImportCompensations && !canImportResults

  const onFormSubmit = ({ importType }: FormData) => {
    if (onSubmit) {
      onSubmit(importType)
    }
  }

  return (
    <Modal
      illustration="table-file"
      title={i18n.t('compensations.PayrollRunCompensationsList.importModal.headerTitle')}
      onClose={onClose}
      disableFocusTrap
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={handleSubmit(onFormSubmit)} disabled={isConfirmDisabled}>
            {i18n.t('common.confirm')}
          </Button>
        </Box>
      }
    >
      <form>
        <Controller
          name="importType"
          control={control}
          render={({ field }) => (
            <>
              <Radio.Wrap>
                <Radio
                  name="importType"
                  value={field.value}
                  onChange={() => canImportCompensations && field.onChange('compensations')}
                  option={{
                    label: i18n.t(
                      'compensations.PayrollRunCompensationsList.importModal.compensationCheckOptionLabel'
                    ),
                    value: 'compensations',
                    disabled: !canImportCompensations,
                  }}
                />
              </Radio.Wrap>

              <Radio.Wrap>
                <Radio
                  name="importType"
                  value={field.value}
                  onChange={() => canImportResults && field.onChange('importResult')}
                  option={{
                    label: i18n.t(
                      'compensations.PayrollRunCompensationsList.importModal.payrollResultsCheckOptionLabel'
                    ),
                    value: 'importResult',
                    disabled: !canImportResults,
                  }}
                />
              </Radio.Wrap>
            </>
          )}
        />
      </form>
    </Modal>
  )
}

export { ImportModal }
